@if (isOpen && displaySrc) {
<div
  #backdrop
  class="picture-modal-backdrop"
  (click)="onBackdropClick($event)"
  role="presentation"
>
  <div
    class="picture-modal-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="displayAlt"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="picture-modal-dialog__close"
      (click)="close($event)"
      aria-label="Luk"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="picture-modal-dialog__content">
      <img
        class="picture-modal-dialog__image"
        [src]="displaySrc"
        [alt]="displayAlt"
      />
    </div>
  </div>
</div>
}
